
















































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
import Groupe from '@/components/Groups/Groupe.vue'
import { showAt, hideAt } from 'vue-breakpoints'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import { getOperationID } from '@/api/operations'
import Alert from '@/components/Alert.vue'
import { IGroup } from '@/types/group'
import orderBy from 'lodash/orderBy'
import chunk from 'lodash/chunk'
import intersection from 'lodash/intersection'
import NewGroupForm from '@/components/Groups/NewGroupForm.vue'
import InfosCollapse from '@/components/Groups/InfosCollapse.vue'
import ButtonWithTooltip from '@/components/Groups/ButtonWithTooltip.vue'
import AperGr from '@/components/Groups/AperGr.vue'

@Component({
    components: {
        AperGr,
        Groupe,
        hideAt,
        showAt,
        Alert,
        NewGroupForm,
        InfosCollapse,
        ButtonWithTooltip,
    },
})
export default class Groups extends Vue {
    apiServices = new ApiService()
    loaded = false
    allGroups = []
    userHobbies: string[] = []
    breakpoints = {
        medium: 992,
        large: Infinity,
    }

    userID: number = null
    opeID: number = null
    currentAperGroup: number = 0
    filter: 'all' | 'filtered' = 'all'

    get sortedGroups() {
        const sortedGroups = orderBy(
            this.allGroups,
            group => {
                return group.users.length
            },
            'desc'
        )
        return sortedGroups
    }

    get canJoinGroup() {
        return this.myGroups.length < 4
    }

    get myGroups() {
        const myGroups = this.sortedGroups.filter((x: any) => {
            for (let i = 0; i < x.users.length; i++) {
                if (
                    x.users[i].id === this.userID &&
                    (x.users[i].state === 'member' ||
                        x.users[i].state === 'waiting')
                ) {
                    return true
                }
            }
            return false
        })
        return myGroups
    }

    get myGroupsWithState() {
        return this.myGroups.map(group => {
            const state = (() => {
                for (let i = 0; i < group.users.length; i++) {
                    if (
                        group.users[i].id === this.userID &&
                        (group.users[i].state === 'member' ||
                            group.users[i].state === 'waiting')
                    ) {
                        return group.users[i].state
                    }
                }
            })()
            return {
                ...group,
                state,
            }
        })
    }

    get myGroupsSortedByState() {
        return orderBy(
            this.myGroupsWithState,
            group => {
                return group.state === 'waiting' ? 1 : -1
            },
            'asc'
        )
    }

    get suggestedGroups() {
        const suggestedGroups = this.sortedGroups.filter((x: any) => {
            for (let i = 0; i < x.users.length; i++) {
                if (
                    x.users[i].id === this.userID &&
                    (x.users[i].state === 'member' ||
                        x.users[i].state === 'waiting')
                ) {
                    return false
                }
            }
            return true
        })
        return suggestedGroups
    }

    get filteredGroups() {
        if (this.filter === 'all') {
            return this.suggestedGroups
        } else {
            const groups = this.suggestedGroups.filter((group: any) => {
                // on récupère les hobbies d'un groupe
                let hobbies = []
                group.users.forEach(user => {
                    user.hobbies.forEach(hobby => {
                        if (hobbies.indexOf(hobby.name) === -1) {
                            hobbies.push(hobby.name)
                        }
                    })
                })
                // on récupère les hobbies en commun
                const intersect = intersection(this.userHobbies, hobbies)
                return intersect.length > 0
            })
            return groups
        }
    }

    /**
     * Découpe le tableau de groups par groupe en tableau de groupe de 5
     */
    get chunkedGroups() {
        return chunk(this.filteredGroups, 5)
    }

    showModal(group) {
        const groupModal = <any>$(this.$refs.groupModal)
        const index = this.filteredGroups.indexOf(group)

        this.currentAperGroup = index

        groupModal.find('.carousel-item').removeClass('active')
        groupModal
            .find(`.carousel-item:nth-child(${index + 1})`)
            .addClass('active')
        groupModal.find('.carousel-inner').height('auto')
        groupModal.modal('show')
    }

    initCarousel() {
        const that = this
        requestAnimationFrame(() => {
            const carousel = <any>$(this.$refs.carouselExampleControlsModal)
            $(carousel).on('slide.bs.carousel', function(e) {
                const slides = $(this)
                    .find('.carousel-item')
                    .toArray()
                const nextSlide = $((<any>e).relatedTarget).get(0)
                that.currentAperGroup = slides.indexOf(nextSlide)

                const nextH = $((<any>e).relatedTarget).height()
                $(this)
                    .find('.carousel-item.active')
                    .parent()
                    .animate({ height: nextH }, null, null, () => {
                        // on utilise un timeout pour éviter un bug d'affichage
                        setTimeout(_ => {
                            $(this)
                                .find('.carousel-inner')
                                .height('auto')
                        }, 200)
                    })
            })
        })
    }

    destroyed() {
        const $newGroupModal = $(this.$refs.newGroupModal) as any
        $newGroupModal.off('hidden.bs.modal', this.resetNewGroupForm)
        const $aperGrpModal = $(this.$refs.aperGrpModal) as any
        $aperGrpModal.off('hidden.bs.modal', this.onModalHidden)
    }

    async created() {
        if (UserModule.token == undefined) {
            UserModule.Init()
        }
        this.userID = UserModule.userInfos.id
        this.opeID = await getOperationID()

        const resp = await this.apiServices.getGroupsByOperation(this.opeID)
        const allGroups = resp.data
        this.allGroups = allGroups
        console.log(JSON.parse(JSON.stringify(allGroups)))

        // get userHobbies
        const buyerResp = await this.apiServices.getBuyer(this.userID)
        const buyer = buyerResp.data
        const userHobbies = buyer.hobbies.map(el => {
            return el.name
        })
        this.userHobbies = userHobbies

        this.loaded = true
        this.initCarousel()
    }

    mounted() {
        const $newGroupModal = $(this.$refs.newGroupModal) as any
        $newGroupModal.on('hidden.bs.modal', this.resetNewGroupForm)
        const $aperGrpModal = $(this.$refs.aperGrpModal) as any
        $aperGrpModal.on('hidden.bs.modal', this.onModalHidden)
    }

    showAlert(obj) {
        if (obj.type === 'success') {
            ;(<any>$(this.$refs.groupModal)).modal('hide')
            ;(<any>$(this.$refs.aperGrpModal)).modal('hide')
        }
        ;(<Alert>this.$refs.alert).handleAlert(obj.type, obj.message)
    }

    onDone() {
        const $newGroupModal = $(this.$refs.newGroupModal) as any
        $newGroupModal.modal('hide')
    }

    onAlert(alert: { type: string; message: string; duration: number }) {
        const $alert = this.$refs.alert as Alert
        $alert.handleAlert(alert.type, alert.message, alert.duration)
    }

    resetNewGroupForm() {
        const $newGroupForm = this.$refs.newGroupForm as NewGroupForm
        $newGroupForm.reset()
    }

    onCreateGroup() {
        const $newGroupModal = $(this.$refs.newGroupModal) as any
        $newGroupModal.modal('show')
    }

    selectedGroupID: number = null
    showGrp(group) {
        console.log(group.id)
        this.selectedGroupID = group.group.id
    }

    showMyModal() {
        const $aperGrpModal = $(this.$refs.aperGrpModal) as any
        $aperGrpModal.modal('show')
    }

    onModalHidden() {
        console.log('modalHidden')
        this.selectedGroupID = null
    }

    // on s'ajoute à un group
    onJoinGroup(args) {
        const { groupID, userData } = args
        const group = this.allGroups.find(group => group.group.id === groupID)
        const userGroup = group.users.find(user => user.id === this.userID)
        if (userGroup) {
            userGroup.state = userData.state
        } else {
            group.users.push({
                ...userData.user,
                state: userData.state,
            })
        }
    }

    // on se supprime d'un group
    onQuitGroup(groupID) {
        const group = this.allGroups.find(group => group.group.id === groupID)

        const userGroup = group.users.find(u => u.id === this.userID)
        const index = group.users.indexOf(userGroup)
        if (index !== -1) {
            group.users.splice(index, 1)
        }
    }
}
